import { Component, HostListener, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, Event} from '@angular/router';
import { Utility } from '../shared/utility/utility';
import { BannerService } from '../services/banner.service';
import { environment } from '../../environments/environment';
import { UserDetailsService } from '../services/user-details.service';
import { EmitterService } from '../services/emitter.service';
import { TranslateService } from "@ngx-translate/core";
import {interval as observableInterval, Subject, takeUntil } from 'rxjs';
import { timerBannerRunningTime } from "../shared/utility/config";
import { bannerState } from '../shared/utility/config';
import * as _ from 'underscore';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
@Component({
  selector: 'app-timer-banner',
  templateUrl: './timer-banner.component.html',
  styleUrls: ['./timer-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})

/* Check that the timer banner should be called on only play user*/
export class TimerBannerComponent implements OnDestroy {
  minimised: boolean = false;
  showBanner: boolean = false;
  windowType : string = undefined;
  banner:{} = undefined;
  bannerSubscription;
  waitingsubscription;
  timeLeft : string = undefined;
  realUser: boolean = false;
  expired :boolean = false;
  bannedpaths = ["gameplay", "deposit", "terms-and-conditions", "responsible-gaming", "setlimits", "accountstatus", "marketing-communication", "login", "completeprofile", "otp", "txn-confirmation", "setlimits", "step3", "register", "withdraw", "success","page=","step="];
  runningTimeSpan: number = 0;
  waitInterval: number = 45000;
  bannerState: bannerState;
  siteUrl= environment.siteUrl;
  destroy$: Subject<boolean> = new Subject<boolean>();

  @HostListener('window:resize') onResize() {
    const ww = document.body.clientWidth;
    if (ww <= 767) {
      this.windowType = "mobile";
    } else {
      this.windowType = "device";
    }
  }
  
  constructor(private router: Router,
              private utility: Utility,
              private bannerService: BannerService,
              private userDetailsService: UserDetailsService,
              private emitterService: EmitterService,
              private translationService: TranslateService) {
    this.runningTimeSpan = timerBannerRunningTime;
    if(!localStorage.getItem("bannerObject")){
      this.updateBannerObject(bannerState.BANNED, this.runningTimeSpan);
    }
    this.emitterService.logoutComplete$.pipe(takeUntil(this.destroy$)).subscribe(logoutStatus => {
      /*During logout if status is expired then status is changed to "banned"*/
      if(this.status === bannerState.SHOWING || this.status === bannerState.RUNNING || this.status === bannerState.MINIMISED){
        /*Only unsubscribe when not there , or else "Cannot read property 'unsubscribe' of undefined" error is thrown*/ 
        this.unSubscribeBannerSubscription();
      } 
      /*Case: If banner has expired or sleep, and user is logging out , it should then change status to "banned */ 
      this.updateBannerObject(bannerState.BANNED,this.runningTimeSpan);
      this.showHideBanner;
    });
    /*
    This emmiter is called both on logout and loggin.This emmiter is particularly used for checking the login
    user status. This was choosen as other emmiters seemed to not work properly.
    */
    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {

      /*If user is real user dont proceed*/
      let customerDetails = this.userDetailsService.getUserProfileDetails();
      if (this.utility.isUserLoggedIn() && customerDetails && customerDetails["userStatus"] === "real") {
        return;
      }
      /*Dont restrict any route here if banner status is banned presently which may be needed in case of page refresh on a banned page, 
      as it will cause failure for logout -> login case*/
      /*LoadBanner only if user is logged in*/
      if(this.utility.isUserLoggedIn() && !_.contains([bannerState.EXPIRED,bannerState.SLEEP],this.status)){
        this.loadbanner();
      }
      /*
        Restricting login after completing registration step1, only when banner has not
        expired. Upadating status to running, untill some other events(emmiter or banned page 
        check) stops the banner from running. Checking for user logged in as, this is also called 
        when user logsout thus updating the logging status of the user. 
        This also takes care of scenerio, when user clicks login in button and login response comes 
        successfully even before navigation ends , due to which url is still '/login'
      */
      if (this.utility.isUserLoggedIn() && (this.pageAllowed() || window.location.pathname.indexOf('login') >= 0)  && !_.contains([bannerState.EXPIRED, bannerState.SLEEP], this.status)) {
        /*Case: Whenever user logs in, timer banner should start from initial time, and this will continue to happen untill user deposits for the first time*/
        this.updateBannerObject(bannerState.RUNNING);
        this.initiateTimer();
      }
      /*if (this.status === "sleep") {
        this.postExpiryProcesses();
      }*/
    });

    /* On deposit successfull, banner should never come up again. In normal deposit methods, we dont query the user's
      status.
    */ 
    this.emitterService.txnComplete$.pipe(takeUntil(this.destroy$)).subscribe(transactionStatus => {
      /* Transaction status is success and banner as a probability of running, then chnage to expired or else its already is in expired state*/
      this.realUser = transactionStatus === 'SUCCESS' ? true : false;
      if (transactionStatus === 'SUCCESS') {
        /*Cancel the subscription right away for any runnable state and update as expired. Only unsubscribe when not there , or else "Cannot read property 'unsubscribe' of undefined" error is thrown*/ 
        this.unSubscribeBannerSubscription();
        this.updateBannerObject(bannerState.EXPIRED,0);
        this.showHideBanner;
      }
    });

    this.emitterService.otpCompleted$.pipe(takeUntil(this.destroy$)).subscribe(completeStatus => {
        this.initiateTimer();
    });

    this.emitterService.depositInitialised$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      if (status === 'depositModalOpen') {
        if (this.status === bannerState.SHOWING || this.status === bannerState.RUNNING || this.status === bannerState.MINIMISED) {
          /*Only unsubscribe when not there , or else "Cannot read property 'unsubscribe' of undefined" error is thrown*/ 
          this.unSubscribeBannerSubscription();
        } 
        /*While deposit opening , if banner already expired, then Keep as expired, else declare as banned*/
        this.updateBannerObject(this.status === bannerState.EXPIRED ? bannerState.EXPIRED : bannerState.BANNED);
        this.showHideBanner();
      } else {
        /*
          The current status should not be "expired". The landing page should not be banned page and if timer was already running then start immediately,
          based on it was minimised or large
        */
        if(this.status !== bannerState.EXPIRED && this.pageAllowed() && !this.realUser){
          /*It was previously running directly start the time and show it by "showing" status*/
          if (this.timeLapse > 0 && this.timeLapse < this.runningTimeSpan ) {
            if(localStorage.getItem("minimised") === "true"){
              this.updateBannerObject(bannerState.MINIMISED);
            }else{
              this.updateBannerObject(bannerState.SHOWING);
            }
            this.startTimer(this.timeLapse);
            this.showHideBanner();
          /*If it was not running previously*/
          }else{
            this.initiateTimer();
          }          
        }
      }
    });
    /* 
      To capture routing changes and display the banner, if page is allowed
    */
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event : Event) => {
      if (event instanceof NavigationEnd) {
        /*If user is real user dont proceed*/
        let customerDetails = this.userDetailsService.getUserProfileDetails();
        /*If user is a realUser , directly make the banner status as expired , or it if the banner is already in expired or sleep state, keep it there, dont let it proceed.
         'this.realuser' is for user becoming real user while timer banner is running, 'customerDetails["userStatus"]' check is for users who are already real*/
        if(this.realUser || _.contains([bannerState.EXPIRED,bannerState.SLEEP],this.status) || ( customerDetails && customerDetails["userStatus"] === "real")){
          this.postExpiryProcesses();
          return;
        }
        /* To be banned page and again moving to a banned page."step2=" is used for deposit modal*/
        if (!this.utility.isUserLoggedIn() || !this.pageAllowed()) {
          this.updateBannerObject(bannerState.BANNED, !localStorage.getItem("bannerObject") ? this.runningTimeSpan : null);
          /*If previous page was not banned and bannerSubscription already was runnings but the present page is banned, so need to stop the subscription*/
          this.unSubscribeBannerSubscription();
        }else{
          /* Was on banned page and again moving to a nonbanned page or was in a non banned page with timer banner already started*/
          /*If banner was closed in minimised state then now open in minimised state*/
          if (this.status === bannerState.BANNED && this.timeLapse > 0){
            if (this.timeLapse < this.runningTimeSpan) {
              if (localStorage.getItem("minimised") === "true") {
                this.updateBannerObject(bannerState.MINIMISED);
              } else {
                /*If previous page was banned and not minimised then show the banner before starting it*/
                this.updateBannerObject(bannerState.SHOWING);
              }
              this.startTimer(this.timeLapse);
            } else {
              /*Allowed page but user went from a banned -> unbanned -> banned in a very short 
              period of time  and stayed there. So after 45 secs subscription was destroyed as 
              state is banned.Now when to come to unbanned page timer should start
              Cannot determine the difference between 45secs expired or not , when user makes the above moves*/
              this.initiateTimer();
            }
          /* Was on non banned page and again moving to a non banned page with timer banner already started*/
          }else if(this.status !== bannerState.BANNED && this.timeLapse > 0 && this.timeLapse < this.runningTimeSpan ){
            this.startTimer(this.timeLapse);
          }
        }
        this.showHideBanner();
      }
    });
  }

  
  get status(){
    let bannerObj = JSON.parse(localStorage.getItem("bannerObject"));
    return bannerObj ? bannerObj["status"] : null;
  }
  get timeLapse(){
    let bannerObj = JSON.parse(localStorage.getItem("bannerObject"));
    return bannerObj ? bannerObj["timeLapse"] : 0;
  }
  updateBannerObject(status : string, timeLapse?: number){
    let bannerObj = {
      "status": status,
      "timeLapse": timeLapse != null && timeLapse >-1 ? timeLapse : this.timeLapse
    }
    localStorage.setItem("bannerObject",JSON.stringify(bannerObj));
  }
  pageAllowed(){
    let allowedPages: boolean = true;
    for (let path in this.bannedpaths) {
      if (window.location.pathname.indexOf(this.bannedpaths[path]) >= 0 || window.location.href.indexOf(this.bannedpaths[path]) >=0) {
        allowedPages = false;
        break;
      }
    }
    return allowedPages;
  }
  showHideBanner() {
    let bannerObj = JSON.parse(localStorage.getItem("bannerObject"));
    switch(bannerObj["status"]){
      case bannerState.BANNED:
        this.updateStatus(false, false, false);
        break;
      case bannerState.EXPIRED:
        this.updateStatus(false, false, false);
        break;
      case bannerState.MINIMISED:
        this.updateStatus(true, false, false);
        localStorage.setItem("minimised", "true");
        break;
      case bannerState.SLEEP:
        this.updateStatus(false, false, true);
        break;
      case bannerState.SHOWING:
        this.updateStatus(false, true, false);
        localStorage.setItem("minimised", "false");
        break;
      case bannerState.RUNNING:
        this.updateStatus(false, false, false);
        localStorage.setItem("minimised", "false");
        break;
    }
  }
  updateStatus(minimisedStatus : boolean, showbannerStatus : boolean, expiredStatus : boolean ) {
    this.minimised = minimisedStatus;
    this.showBanner = showbannerStatus;
    this.expired = expiredStatus;
  }
  /*This function is called when cancel button is clicked from a.Max timer banner b.Expired banner c. directly on Minimised banner*/
  cancelBanner() {
    /*Case when max banner is shown, timer is running. Clicking button means user wants to minimise the banner*/
    if(this.timeLapse > 0 && this.status === bannerState.SHOWING){
      this.minimizeOriginalBanner();
    }else if(this.timeLapse > 0 && this.status === bannerState.MINIMISED){
      this.updateBannerObject(bannerState.SHOWING);
    }else if(this.status === bannerState.SLEEP){
      this.postExpiryProcesses();
    }
    this.showHideBanner();
  }
  minimizeOriginalBanner(){
    this.updateBannerObject(bannerState.MINIMISED);
    this.showHideBanner();
  }
  postExpiryProcesses(){
    this.updateBannerObject(bannerState.EXPIRED, 0);
    this.showHideBanner();
    localStorage.removeItem("selectedBanner");
  }
  /*
  ** Loading the banner after 40secs (total 45sec= 40sec+5sec)
  ** Function checks for banner expiry, if page is allowed. if both are true, then subscribes to the Observable .interval for the timer time.
  ** Responsible for recieving the banner and then replacing the required values and creating the array for frontend display
  */
  loadbanner() {
    let self = this;
    Promise.resolve(this.bannerService.getTimeBanners({ 'zoneId': '9' })).then(banners => {
      if (!_.isEmpty(banners) && banners.length > 0) {
        let bannerLen = banners.length;
        this.banner = undefined;
        /*Test 1.already some bannerid is present in localstorage 2. present bannerID has index less than equal to the number of banners in the response(in case of banner deletion from CMS)*/
        if (localStorage.getItem("selectedBanner")) {
          this.banner = _.filter(banners, function (banner) {
            return banner["id"] == localStorage.getItem("selectedBanner"); // == as banner["id"] is number and getItem returns String
          });
          this.banner = this.banner[0];
        }
        /*It banner already not present then choose a random banner*/
        if (!this.banner) {
          let i = Math.floor(Math.random() * bannerLen);
          this.banner = banners[i];
          localStorage.setItem("selectedBanner", this.banner["id"]);
        }
        /*Replace fields: siteUrl,name in selected banner with dynamic values*/
        this.banner["content"] = this.banner["content"].replace(new RegExp('{{siteUrl}}', 'g'), environment.siteUrl);
        this.banner["content"] = this.banner["content"].replace(new RegExp('{{name}}', 'g'), this.userDetailsService.getUserProfileDetails()['firstName']);

        setTimeout(function () {
          $('.timer-bannner--mini-right-content').find('p').html($('.minimise-title').text());
          $('.max_banner_content').html($('.maxbanner').html());
          $('.timer-banner-expired-content').html($('.expiredbanner').html());
          self.bannerButtonEvents(self);
        });
      }
    });
  }
  bannerButtonEvents(self){
    let bannerButtons = $('.cm-slider__btn--cta--deposit');
    _.each(bannerButtons, function (buttons) {
      $(buttons).data('target', self.banner["targetMemberUrl"]);
    })
    $('.cm-slider__btn--cta--deposit').on('click', function () {
      if ($(this).data("target") == "deposit") {
        self.emitterService.broadcastModalState({name:"paymentModal",state:"open",cashierType:"deposit"});
      }
    });
    let bannersButtonsbonus = $('.cm-slider__btn--cta--deposit-bonus');
    _.each(bannersButtonsbonus, function (buttons) {
      $(buttons).data('target', self.banner["targetUrl"]);
    })
    $('.cm-slider__btn--cta--deposit-bonus').on('click', function () {
      self.emitterService.broadcastModalState({name:"paymentModal",state:"open",cashierType:"deposit"});
      self.router.navigate([], { relativeTo: this.activatedRoute, queryParams: { source: "website", service: "deposit", bonus: $(this).data("target"), step: '1' }, queryParamsHandling: "merge", });
    })
    $('.timer-banner--closeicon').unbind('click').bind('click', function () {
      self.cancelBanner();
    });
  }
  
  initiateTimer(){
    this.updateBannerObject(this.status === bannerState.MINIMISED ? bannerState.MINIMISED: bannerState.RUNNING);
    if (this.waitingsubscription){
      this.waitingsubscription.unsubscribe();
    }
    this.waitingsubscription = observableInterval(this.waitInterval).subscribe(x => {
      this.waitingsubscription.unsubscribe();
      let time = this.timeLapse; 
      /*If after waiting time it is found that the ultimate status is banned or expired, then stop the process*/
      if(time <= 0 || _.contains([bannerState.BANNED,bannerState.EXPIRED],this.status)){
        return;
      }
      /*Case user has reached sleep state , which is expired banner is open , then he refreshes 
      if (this.status === "sleep") {
        this.postExpiryProcesses();
      }
      /*If it was in minimised state before, should open in minimised state*/
      if(localStorage.getItem("minimised") === "true"){
        this.updateBannerObject(bannerState.MINIMISED,time);
      }else{
        this.updateBannerObject(bannerState.SHOWING,time);
      }
      this.showHideBanner();
      this.startTimer(time);
    });
  }
  startTimer(time : number ) {
    this.unSubscribeBannerSubscription();
    this.bannerSubscription = observableInterval(1000).subscribe(x => {
      if (time > 0) {
        time--;
        let minutes = Math.floor(time / 60);
        let seconds = time - (minutes * 60);
        if (minutes >= 0 && minutes < 10 && seconds >= 0 && seconds < 10) {
          this.timeLeft = '0' + minutes + ":0" + seconds;
        } else if (minutes >= 0 && minutes < 10) {
          this.timeLeft = '0' + minutes + ":" + seconds;
        } else if (seconds >= 0 && seconds < 10) {
          this.timeLeft = minutes + ":0" + seconds;
        } else {
          this.timeLeft = minutes + ":" + seconds;
        }
        $('.timer-banners--active .timer-banner--header h1').html(this.translationService.instant('timerBanner.offerExpires') + this.timeLeft);
        this.updateBannerObject(this.status === bannerState.MINIMISED ? bannerState.MINIMISED: bannerState.SHOWING,time);
      } else {
        $('.timer-banners--expired .timer-banner--header h1').html(this.translationService.instant('timerBanner.offerExpired'));
        this.unSubscribeBannerSubscription();
        this.updateBannerObject(bannerState.SLEEP,0);
        this.showHideBanner();
      }
    });
  }
  unSubscribeBannerSubscription() {
    if (this.bannerSubscription){
      this.bannerSubscription.unsubscribe();
    }
  }
  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.bannerSubscription.unsubscribe();
  }

}
